import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [
    MatIcon,
  ],
  templateUrl: './icon.component.html',
  encapsulation: ViewEncapsulation.None
})
export class IconComponent {
  @Input() svgIcon: string = '';
  @Input() icon: string = ''
  @Input() class: string = ''
  isBrowser = false;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: any) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
}
